import firebase from "config/firebase";
import { toast } from "react-toastify";
export const getPlayers = (lastDocument, filter, onComplete = () => {}) => {
  return async (dispatch) => {
    try {
      let querya = await firebase
        .firestore()
        .collection("users")
        .where("role", "==", "athlete");

      if (filter) {
        querya = querya.where("athleteID", "==", filter);
      }

      querya = querya.orderBy("first_name", "desc");

      if (lastDocument) {
        querya = querya.startAfter(lastDocument);
      }

      querya
        .limit(5)
        .get()
        .then(async (query) => {
          var athletes = [];
          const athleteDocs = query.docs;

          for await (let doc of athleteDocs) {
            let AthleteEarning = await firebase
              .firestore()
              .collection("wallet")
              .where("userId", "==", doc.id)
              .get();

            athletes.push({
              id: doc.id,
              ...doc.data(),
              totalEarning: AthleteEarning?.docs[0]?.data()?.earnings
                ? AthleteEarning?.docs[0]?.data()?.earnings
                : 0,
            });
          }

          let hasMoreDocument = athletes.length >= 5;

          dispatch({
            type: lastDocument ? "GET_ATHLETES_LOAD_MORE" : "GET_ATHLETES",
            payload: {
              data: athletes,
              hasMoreDocument,
              lastDocument: athleteDocs[athletes.length - 1] || null,
            },
          });

          onComplete();
        });
    } catch (error) {
      console.error(error);
    }
  };
};

export const getLicenses = () => {
  return async (dispatch) => {
    firebase
      .firestore()
      .collection("license_purchases")
      .onSnapshot((query) => {
        var license = [];
        query.forEach((doc) => {
          license.push({ id: doc.id, ...doc.data() });
        });
        dispatch({
          type: "GET_LICENSE",
          payload: license,
        });
      });
  };
};
export const getSignUpPayments = () => {
  return async (dispatch) => {
    firebase
      .firestore()
      .collection("signup_payments")
      .onSnapshot((query) => {
        var temp = [];
        query.forEach((doc) => {
          temp.push({ id: doc.id, ...doc.data() });
        });
        dispatch({
          type: "GET_SIGNUP_PAYMENTS",
          payload: temp,
        });
      });
  };
};
export const getSinglePlayerLicenses = (id) => {
  return async (dispatch) => {
    firebase
      .firestore()
      .collection("license_purchases")
      .where("athlete_id", "==", id)
      .onSnapshot((query) => {
        var license = [];
        query.forEach((doc) => {
          license.push({ id: doc.id, ...doc.data() });
        });
        dispatch({
          type: "GET_SINGLE_PLAYER_LICENSE",
          payload: license,
        });
      });
  };
};

export const getSinglePlayer = (id) => {
  return async (dispatch) => {
    firebase
      .firestore()
      .collection("users")
      .doc(id)
      .onSnapshot((query) => {
        dispatch({
          type: "GET_SINGLE_PLAYER",
          payload: query.data(),
        });
      });
  };
};
export const blockPlayer = (blocked, id, onComplete = () => {}) => {
  return async (dispatch) => {
    await firebase
      .firestore()
      .collection("users")
      .doc(id)
      .update({ blocked: blocked })
      .then((res) => {
        if (blocked == true) {
          toast.warning("Player Blocked");
        } else {
          toast.success("Player Unblocked");
        }
        dispatch({
          type: "IS_PLAYER_BLOCK",
          payload: { id: id, block: blocked },
        });
        onComplete();
      });
  };
};
export const suspendPlayer = (blocked, id) => {
  return async (dispatch) => {
    let library = await firebase
      .firestore()
      .collection("a4b_library_stats")
      .where("athleteID", "==", id)
      .get();
    library.forEach((doc) => {
      doc.ref
        .delete()
        .then(() => {
        })
        .catch((error) => {
          console.error("Error deleting document: ", error);
        });
    });
    firebase
      .firestore()
      .collection("users")
      .doc(id)
      .update({ blocked: blocked })
      .then((res) => {});
  };
};

export const getChatEarning = () => {
  return async (dispatch) => {
    dispatch(chatEarningLoading(true));

    let val = 0;
    let chatEarningData = await firebase
      .firestore()
      .collection("a4b_chat")
      .where("athlete_payment", "==", true)
      .get();

    for (let doc of chatEarningData.docs) {
      val += (Number(doc.data()?.paid_amount.value) / 100) * 24;
    }
    dispatch({
      type: "GET_CHAT_EARNING",
      payload: val,
    });
    dispatch(chatEarningLoading(false));
  };
};

export const chatEarningLoading = (val) => async (dispatch) => {
  dispatch({ type: "CHAT_EARNING_LOADING", payload: val });
};
